import { ReactElement } from 'react';
import { useRoutes, useAwsGetter } from '@localstack/services';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { Breadcrumbs, FirehoseStreamDetails } from '@localstack/ui';

import { DEFAULT_FIREHOSE_ROUTES } from '@localstack/constants';

import { FirehoseProps } from './types';

export const FirehoseStream = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_FIREHOSE_ROUTES,
}: FirehoseProps): ReactElement => {
  const { goto } = useRoutes();
  const { deliveryStreamName } = useParams<'deliveryStreamName'>();

  const { data: deliveryStream } = useAwsGetter(
    'Firehose',
    'describeDeliveryStream',
    [{ DeliveryStreamName: deliveryStreamName }],
    { clientOverrides },
  );

  return (
    <Layout
      documentTitle="Data Firehose: Delivery Stream Details"
      title={
        <Box>
          <Typography variant="h4">Delivery Stream Details</Typography>
          <Breadcrumbs
            mappings={[
              ['Firehose', () => goto(routes.RESOURCES_FIREHOSE_STREAMS)],
              ['Delivery Streams', () => goto(routes.RESOURCES_FIREHOSE_STREAMS)],
              [deliveryStreamName, null],
            ]}
          />
        </Box>
      }
    >
      <Card>
        <CardContent>
          <FirehoseStreamDetails deliveryStream={deliveryStream} />
        </CardContent>
      </Card>
    </Layout>
  );
};
